import React, {useEffect, useState} from 'react';
import {Button, Modal, Space, Typography} from "antd";
import {useTimer} from "react-timer-hook";
import {ClockCircleOutlined} from "@ant-design/icons";
import {useMutation} from "@tanstack/react-query";
import {getRefreshTokenAPI} from "../../api/AuthAPI";
import axios from "axios";
import UseTranslate from "../../hooks/UseTranslate";

const SessionTimer = ({ initialExpiryTimestamp  }) => {
    const { Text } = Typography;
    const [expiryTimestamp, setExpiryTimestamp] = useState(initialExpiryTimestamp);
    const [modal, contextHolder] = Modal.useModal()
    const translate = UseTranslate();
    const alertTimeMM = 5;
    const { restart, seconds, minutes } = useTimer({ expiryTimestamp: initialExpiryTimestamp || new Date(),
        onExpire: () => expiredModal()});


    useEffect(() => {
        // 만료 5분 전 (300초 전)
        if (!expiryTimestamp) return;

        // 만료 5분 전 시간 계산 (밀리초 단위)
        const alertTime = expiryTimestamp - (alertTimeMM * 60   * 1000);

        // 현재 시간을 기준으로 알림을 띄울지 확인
        const timeout = setTimeout(() => {
            if (Date.now() >= alertTime) {
                extendModal();
            }
        }, alertTime - Date.now());

        return () => clearTimeout(timeout);

    }, [expiryTimestamp]);

    const extendModal = () => {
        modal.confirm({
            title: 'Login Session Expired',
            content: (
                <div style={{paddingTop: 12, fontSize: 'medium'}}>
                    You have 5 minutes left in your login session.  <br/> Would you like to extend it?
                </div>
            ),
            centered: true,
            keyboard: false,
            okButtonProps: { type: 'primary' },
            cancelButtonProps: { type: 'default' },
            autoFocusButton: null,
            onOk: () => {
                onClickExtendSession();
            }
        })
    }

    const expiredModal = () => {
        modal.error({
            title: 'Login Session Expired',
            content: (
                <div style={{paddingTop: 12, fontSize: 'medium'}}>
                    Your login session has expired. <br/> Please log in again.
                </div>
            ),
            centered: true,
            keyboard: false,
            okButtonProps: { type: 'primary', danger: true },
            autoFocusButton: null,
            onOk: () => {
                window.location.href = window.location.origin;
            }
        })
    }

    const onClickExtendSession = () => {
        extendMutation.mutate({accessToken: sessionStorage.getItem('token'), refreshToken: sessionStorage.getItem('re-token')});
    }

    const extendMutation = useMutation(data => getRefreshTokenAPI(data), {
        onSuccess: res => {
            const newExpiryTimestamp = res.data.accessTokenExpiresIn; // 새로운 만료 시간

            sessionStorage.setItem('token', res.data.accessToken);
            sessionStorage.setItem('re-token', res.data.refreshToken);
            sessionStorage.setItem('exp', newExpiryTimestamp);
            axios.defaults.headers['X-AUTH-TOKEN'] = `Bearer ${res.data.accessToken}`;

            // 🔹 새로운 만료 시간으로 갱신 및 타이머 재시작
            setExpiryTimestamp(newExpiryTimestamp);
            restart(newExpiryTimestamp - 1000);
        }
    });

    return (
        <>
            <Space.Compact>
                <Button icon={<ClockCircleOutlined />} type='text' style={{border: '1px solid #d9d9d9', pointerEvents: 'none'}} shape='round'>
                    <Text>{minutes < 10 ? `0${minutes}` : minutes} : {seconds < 10 ? `0${seconds}` : seconds}</Text>
                </Button>
                <Button shape='round' onClick={onClickExtendSession}>
                    {translate('extend')}
                </Button>
            </Space.Compact>
            {contextHolder}
        </>
    );
};

export default SessionTimer;